import { axiosInstance } from "./config";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const subscriptionUrl = 'subscriptions'

export function useInitPayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      return axiosInstance.post(subscriptionUrl+'/payments/init_payment/', data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
}

export function useFinalizePayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      return axiosInstance.post(subscriptionUrl + '/payments/finalize_payment/', data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
}

export function useGetTemplates() {
  return useQuery({
    queryKey: ['subscriptions', 'templates'],
    queryFn: async () => {
      return axiosInstance.get(subscriptionUrl + '/templates/');
    },
  });
}

export function useGetCreditBundles() {
  return useQuery({
    queryKey: ['subscriptions', 'credit-bundles'],
    queryFn: async () => {
      return axiosInstance.get(subscriptionUrl + '/templates/credit_bundles/');
    },
  });
}

export function useGetPaymentHistory() {
  return useQuery({
    queryKey: ['subscriptions', 'payments'],
    queryFn: async () => {
      return axiosInstance.get(subscriptionUrl + '/payments/');
    },
  });
}
